<template>
    <div>
        <NavbarOne/>

        <div class="flex items-center gap-4 flex-wrap bg-overlay p-14 sm:p-16 before:bg-title before:bg-opacity-70" :style="{backgroundImage:'url('+ bg + ')'}">
            <div class="text-center w-full">
                <h2 class="text-white text-8 md:text-[40px] font-normal leading-none text-center">{{ pageTitle }}</h2>
                <ul class="flex items-center justify-center gap-[10px] text-base md:text-lg leading-none font-normal text-white mt-3 md:mt-4 flex-wrap">
                    <li><router-link to="/index-v2">Home</router-link></li>
                    <li>/</li>
                    <li class="text-primary">{{ pageTitle }}</li>
                </ul>
            </div>
        </div>

        <div class="s-py-100">
            <div class="container">
                <div class="max-w-[1477px] mx-auto flex items-start justify-between gap-8 md:gap-10 flex-col lg:flex-row">
                    <div class="grid gap-[15px] lg:max-w-[320px] w-full sm:grid-cols-2 lg:grid-cols-1" data-aos="fade-up">
                        <div class="bg-[#F8F8F9] dark:bg-dark-secondary p-5 sm:p-[30px] sm:col-span-2 lg:col-span-1">
                            <h4 class="font-medium leading-none text-xl sm:text-2xl mb-5 sm:mb-6">Search</h4>
                            <form class="relative" @submit.prevent="applySearch">
                                <input
                                    v-model="searchTerm"
                                    type="search"
                                    class="w-full h-12 bg-white dark:bg-title border border-[#E3E5E6] dark:border-white/10 text-title dark:text-white focus:border-primary pl-4 pr-11 outline-none duration-300"
                                    placeholder="Search products..."
                                    aria-label="Search products"
                                >
                                <button type="submit" class="absolute right-0 top-0 h-12 w-11 flex items-center justify-center text-paragraph dark:text-white-light hover:text-primary duration-300" aria-label="Search">
                                    <i class="mdi mdi-magnify text-[20px]"></i>
                                </button>
                            </form>
                            <button
                                v-if="route.query.search"
                                type="button"
                                class="mt-3 text-sm text-primary hover:underline"
                                @click="clearSearch"
                            >
                                Clear "{{ route.query.search }}"
                            </button>
                        </div>

                        <div class="bg-[#F8F8F9] dark:bg-dark-secondary p-5 sm:p-[30px]">
                            <div class="flex items-center justify-between gap-4 mb-5 sm:mb-6">
                                <h4 class="font-medium leading-none text-xl sm:text-2xl">Categories</h4>
                                <button
                                    v-if="selectedCategoryId"
                                    type="button"
                                    class="text-sm font-medium text-primary"
                                    @click="clearFilters"
                                >
                                    Clear
                                </button>
                            </div>

                            <div v-if="categoriesLoading" class="text-base text-paragraph dark:text-white-light">
                                Loading filters...
                            </div>

                            <div v-else class="grid gap-5">
                                <button
                                    type="button"
                                    class="categoryies-iteem flex items-center gap-[10px] text-left"
                                    @click="clearFilters"
                                >
                                    <span class="w-4 h-4 rounded-[5px] border border-title dark:border-white flex items-center justify-center duration-300"
                                        :class="!selectedCategoryId ? 'bg-primary border-primary' : ''">
                                        <svg class="duration-300" :class="!selectedCategoryId ? 'opacity-100' : 'opacity-0'" width="9" height="8" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3.05203 7.04122C2.87283 7.04122 2.69433 6.97322 2.5562 6.83864L0.532492 4.8553C0.253409 4.58189 0.249159 4.13351 0.522576 3.85372C0.796701 3.57393 1.24578 3.57039 1.52416 3.84309L3.05203 5.34122L7.61512 0.868804C7.89491 0.595387 8.34328 0.59822 8.6167 0.87872C8.89082 1.1578 8.88657 1.60689 8.60749 1.8803L3.54787 6.83864C3.40974 6.97322 3.23124 7.04122 3.05203 7.04122Z" fill="white"/>
                                        </svg>
                                    </span>
                                    <span class="text-title dark:text-white block sm:leading-none transform translate-y-[1px] duration-300 select-none">All Products</span>
                                </button>

                                <div v-for="category in categories" :key="category.id">
                                    <button
                                        type="button"
                                        class="categoryies-iteem flex items-center gap-[10px] text-left w-full"
                                        @click="toggleCategory(category)"
                                    >
                                        <span class="w-4 h-4 rounded-[5px] border border-title dark:border-white flex items-center justify-center duration-300"
                                            :class="selectedCategoryId === category.id ? 'bg-primary border-primary' : ''">
                                            <svg class="duration-300" :class="selectedCategoryId === category.id ? 'opacity-100' : 'opacity-0'" width="9" height="8" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M3.05203 7.04122C2.87283 7.04122 2.69433 6.97322 2.5562 6.83864L0.532492 4.8553C0.253409 4.58189 0.249159 4.13351 0.522576 3.85372C0.796701 3.57393 1.24578 3.57039 1.52416 3.84309L3.05203 5.34122L7.61512 0.868804C7.89491 0.595387 8.34328 0.59822 8.6167 0.87872C8.89082 1.1578 8.88657 1.60689 8.60749 1.8803L3.54787 6.83864C3.40974 6.97322 3.23124 7.04122 3.05203 7.04122Z" fill="white"/>
                                            </svg>
                                        </span>
                                        <span class="text-title dark:text-white block sm:leading-none transform translate-y-[1px] duration-300 select-none">{{ category.name }}</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="bg-[#F8F8F9] dark:bg-dark-secondary p-5 sm:p-[30px]">
                            <h4 class="font-medium leading-none text-xl sm:text-2xl mb-5 sm:mb-6">Price Range</h4>
                            <div class="grid gap-5">
                                <div class="flex items-center justify-between gap-3 text-sm font-medium text-title dark:text-white">
                                    <span>{{ formattedDraftMin }}</span>
                                    <span>{{ formattedDraftMax }}</span>
                                </div>
                                <div class="relative h-10">
                                    <div class="absolute top-1/2 left-0 right-0 h-[6px] -translate-y-1/2 rounded-full bg-[#D9DDE2] dark:bg-[#374151]"></div>
                                    <div
                                        class="absolute top-1/2 h-[6px] -translate-y-1/2 rounded-full bg-primary"
                                        :style="rangeTrackStyle"
                                    ></div>
                                    <input
                                        v-model="draftMinPrice"
                                        type="range"
                                        class="shop-range-input"
                                        :min="priceBounds.min"
                                        :max="priceBounds.max"
                                        :step="sliderStep"
                                        @input="syncDraftRange('min')"
                                        @change="applyPriceSlider"
                                    >
                                    <input
                                        v-model="draftMaxPrice"
                                        type="range"
                                        class="shop-range-input"
                                        :min="priceBounds.min"
                                        :max="priceBounds.max"
                                        :step="sliderStep"
                                        @input="syncDraftRange('max')"
                                        @change="applyPriceSlider"
                                    >
                                </div>
                                <div class="flex items-center gap-3">
                                    <button
                                        type="button"
                                        class="btn btn-outline btn-sm"
                                        data-text="Apply"
                                        @click="applyPriceSlider"
                                    >
                                        <span>Apply</span>
                                    </button>
                                    <button
                                        v-if="hasCustomPriceRange"
                                        type="button"
                                        class="text-sm font-medium text-primary"
                                        @click="resetPriceSlider"
                                    >
                                        Reset
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="bg-[#F8F8F9] dark:bg-dark-secondary p-5 sm:p-[30px]">
                            <h4 class="font-medium leading-none text-xl sm:text-2xl mb-5 sm:mb-6">Current Selection</h4>
                            <div class="grid gap-4">
                                <div class="text-base text-title dark:text-white">
                                    <span class="font-medium">Category:</span>
                                    <span class="text-paragraph dark:text-white-light ml-2">{{ selectedCategory?.name || 'All categories' }}</span>
                                </div>
                                <div class="text-base text-title dark:text-white">
                                    <span class="font-medium">Price:</span>
                                    <span class="text-paragraph dark:text-white-light ml-2">{{ activePriceRangeLabel }}</span>
                                </div>
                                <router-link to="/shop-v2" class="btn btn-outline btn-sm" data-text="Browse Collections">
                                    <span>Browse Collections</span>
                                </router-link>
                            </div>
                        </div>

                        <router-link to="/shop-v2" class="hidden lg:block">
                            <img class="w-full" :src="card" alt="shop-card">
                        </router-link>
                    </div>

                    <div class="lg:max-w-[1100px] w-full" data-aos="fade-up" data-aos-delay="200">
                        <div class="flex items-start justify-between gap-5 flex-col xl:flex-row mb-8 md:mb-10">
                            <div class="max-w-[640px]">
                                <span class="text-sm uppercase tracking-[0.2em] text-primary">Catalog</span>
                                <h3 class="mt-4 font-semibold leading-tight text-title dark:text-white">{{ pageTitle }}</h3>
                                <p class="mt-4 text-base md:text-lg text-paragraph dark:text-white-light">
                                    {{ selectedCategory?.description || 'Browse all available pieces and narrow the catalog using the category filters on the left.' }}
                                </p>
                            </div>
                            <div class="flex flex-wrap gap-3">
                                <div ref="sortDropdownRef" class="relative min-w-[220px]">
                                    <button
                                        type="button"
                                        class="flex h-[54px] w-full items-center justify-between rounded-full border border-line bg-[#F8F8F9] px-5 text-left text-sm md:text-base text-title transition hover:border-primary dark:border-line-dark dark:bg-dark-secondary dark:text-white"
                                        @click="sortDropdownOpen = !sortDropdownOpen"
                                    >
                                        <span>{{ selectedSortLabel }}</span>
                                        <span
                                            class="lnr lnr-chevron-down text-sm transition duration-300"
                                            :class="sortDropdownOpen ? 'rotate-180' : ''"
                                        ></span>
                                    </button>

                                    <div
                                        v-if="sortDropdownOpen"
                                        class="absolute left-0 right-0 top-[calc(100%+10px)] z-30 overflow-hidden rounded-[18px] border border-line bg-white p-2 shadow-[0_18px_45px_rgba(15,23,42,0.14)] dark:border-line-dark dark:bg-title"
                                    >
                                        <button
                                            v-for="option in sortOptions"
                                            :key="option.value"
                                            type="button"
                                            class="flex w-full items-center justify-between rounded-[12px] px-4 py-3 text-left text-sm md:text-base transition"
                                            :class="selectedSort === option.value
                                                ? 'bg-primary text-white'
                                                : 'text-title hover:bg-[#F8F8F9] dark:text-white dark:hover:bg-dark-secondary'"
                                            @click="selectSort(option.value)"
                                        >
                                            <span>{{ option.label }}</span>
                                            <span
                                                v-if="selectedSort === option.value"
                                                class="lnr lnr-checkmark-circle text-sm"
                                            ></span>
                                        </button>
                                    </div>
                                </div>
                                <span v-if="selectedCategory" class="inline-flex items-center rounded-full bg-[#F8F8F9] dark:bg-dark-secondary px-4 py-3 text-sm md:text-base text-title dark:text-white">
                                    {{ selectedCategory.name }}
                                </span>
                            </div>
                        </div>

                        <div v-if="productsLoading" class="text-center py-16 text-base md:text-lg text-paragraph dark:text-white-light">
                            Loading products...
                        </div>
                        <div v-else-if="productsError" class="text-center py-16 text-base md:text-lg text-[#E13939]">
                            {{ productsError }}
                        </div>
                        <div v-else-if="!products.length" class="text-center py-16 bg-[#F8F8F9] dark:bg-dark-secondary text-base md:text-lg text-paragraph dark:text-white-light">
                            No products found for this selection yet.
                        </div>
                        <template v-else>
                            <LayoutOne
                                :classList="'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-5 sm:gap-8'"
                                :productList="products"
                            />
                            <div class="mt-10 md:mt-12 flex items-center justify-center gap-[10px] flex-wrap">
                                <button
                                    type="button"
                                    class="text-title dark:text-white text-xl disabled:opacity-30"
                                    :disabled="!pagination.prevPage"
                                    @click="goToPage(pagination.currentPage - 1)"
                                >
                                    <span class="lnr lnr-arrow-left"></span>
                                </button>
                                <button
                                    v-for="page in visiblePages"
                                    :key="page"
                                    type="button"
                                    class="w-8 sm:w-10 h-8 sm:h-10 bg-title bg-opacity-5 flex items-center justify-center leading-none text-base sm:text-lg font-medium transition-all duration-300 dark:bg-white dark:bg-opacity-5"
                                    :class="page === pagination.currentPage ? 'text-white bg-primary dark:bg-primary' : 'text-title hover:bg-opacity-100 hover:text-white dark:text-white dark:hover:text-title dark:hover:bg-opacity-100'"
                                    @click="goToPage(page)"
                                >
                                    {{ String(page).padStart(2, '0') }}
                                </button>
                                <button
                                    type="button"
                                    class="text-title dark:text-white text-xl disabled:opacity-30"
                                    :disabled="!pagination.nextPage"
                                    @click="goToPage(pagination.currentPage + 1)"
                                >
                                    <span class="lnr lnr-arrow-right"></span>
                                </button>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>

        <FooterOne/>

        <ScrollToTop/>
    </div>
</template>

<script setup>
    import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue';
    import { useRoute, useRouter } from 'vue-router';
    import NavbarOne from '@/components/navbar/navbar-one.vue';
    import FooterOne from '@/components/footer/footer-one.vue';
    import ScrollToTop from '@/components/scroll-to-top.vue';
    import LayoutOne from '@/components/product/layout-one.vue';
    import bg from '@/assets/img/shortcode/breadcumb.jpg'
    import card from '@/assets/img/thumb/shop-card.jpg'
    import Aos from 'aos';
    import { mapCategory, mapProductCard, storefrontRequest } from '@/lib/storefront-api';
    import { setSeo } from '@/lib/seo';

    const route = useRoute();
    const router = useRouter();
    const searchTerm = ref(route.query.search || '');

    // Search lives in the URL like the other filters, so results stay shareable and
    // the back button behaves.
    const applySearch = () => {
        const search = searchTerm.value.trim();
        router.push({ query: { ...route.query, search: search || undefined, page: undefined } });
    };

    const clearSearch = () => {
        searchTerm.value = '';
        applySearch();
    };

    const categories = ref([]);
    const products = ref([]);
    const categoriesLoading = ref(true);
    const productsLoading = ref(true);
    const productsError = ref('');
    const sortDropdownOpen = ref(false);
    const sortDropdownRef = ref(null);
    const priceBounds = ref({ min: 0, max: 5000 });
    const sortOptions = [
        { value: 'featured', label: 'Featured' },
        { value: 'newest', label: 'Newest' },
        { value: 'price_low_high', label: 'Price: Low to High' },
        { value: 'price_high_low', label: 'Price: High to Low' },
    ];
    const pagination = ref({
        currentPage: 1,
        lastPage: 1,
        prevPage: null,
        nextPage: null,
        total: 0,
    });
    const selectedSort = ref(route.query.sort || 'featured');
    const draftMinPrice = ref(0);
    const draftMaxPrice = ref(5000);

    const selectedCategoryId = computed(() => {
        const value = Number(route.query.category || '');
        return Number.isFinite(value) && value > 0 ? value : null;
    });

    const selectedCategory = computed(() =>
        categories.value.find((category) => category.id === selectedCategoryId.value) || null
    );

    const pageTitle = computed(() => selectedCategory.value?.name || 'All Products');
    const selectedSortLabel = computed(() =>
        sortOptions.find((option) => option.value === selectedSort.value)?.label || 'Featured'
    );
    const currentMinPrice = computed(() => {
        const value = Number(route.query.min_price);
        return Number.isFinite(value) ? value : priceBounds.value.min;
    });
    const currentMaxPrice = computed(() => {
        const value = Number(route.query.max_price);
        return Number.isFinite(value) ? value : priceBounds.value.max;
    });
    const hasCustomPriceRange = computed(() =>
        currentMinPrice.value > priceBounds.value.min || currentMaxPrice.value < priceBounds.value.max
    );
    const activePriceRangeLabel = computed(() =>
        hasCustomPriceRange.value
            ? `${formatCurrency(currentMinPrice.value)} - ${formatCurrency(currentMaxPrice.value)}`
            : 'All Prices'
    );
    const formattedDraftMin = computed(() => formatCurrency(draftMinPrice.value));
    const formattedDraftMax = computed(() => formatCurrency(draftMaxPrice.value));
    const sliderStep = computed(() => {
        const spread = Math.max(priceBounds.value.max - priceBounds.value.min, 1);
        return Math.max(1, Math.round(spread / 100));
    });
    const rangeTrackStyle = computed(() => {
        const min = priceBounds.value.min;
        const max = priceBounds.value.max;
        const spread = Math.max(max - min, 1);
        const left = ((draftMinPrice.value - min) / spread) * 100;
        const right = ((draftMaxPrice.value - min) / spread) * 100;

        return {
            left: `${left}%`,
            width: `${Math.max(right - left, 0)}%`,
        };
    });

    const visiblePages = computed(() => {
        const total = pagination.value.lastPage || 1;
        const current = pagination.value.currentPage || 1;
        const start = Math.max(1, current - 1);
        const end = Math.min(total, current + 1);
        const pages = [];

        for (let page = start; page <= end; page += 1) {
            pages.push(page);
        }

        return pages;
    });

    function updateRoute(query) {
        router.replace({
            path: '/shop-v2',
            query,
        });
    }

    function clearFilters() {
        selectedSort.value = 'featured';
        draftMinPrice.value = priceBounds.value.min;
        draftMaxPrice.value = priceBounds.value.max;
        updateRoute({
            sort: 'featured',
        });
    }

    function toggleCategory(category) {
        if (selectedCategoryId.value === category.id) {
            clearFilters();
            return;
        }

        updateRoute({
            category: category.id,
            sort: selectedSort.value,
            ...(hasCustomPriceRange.value ? {
                min_price: draftMinPrice.value,
                max_price: draftMaxPrice.value,
            } : {}),
        });
    }

    function applySort() {
        sortDropdownOpen.value = false;
        updateRoute({
            ...route.query,
            sort: selectedSort.value,
            page: undefined,
        });
    }

    function selectSort(value) {
        selectedSort.value = value;
        applySort();
    }

    function syncDraftRange(target) {
        if (target === 'min' && draftMinPrice.value > draftMaxPrice.value) {
            draftMaxPrice.value = draftMinPrice.value;
        }

        if (target === 'max' && draftMaxPrice.value < draftMinPrice.value) {
            draftMinPrice.value = draftMaxPrice.value;
        }
    }

    function applyPriceSlider() {
        updateRoute({
            ...route.query,
            sort: selectedSort.value,
            min_price: draftMinPrice.value <= priceBounds.value.min ? undefined : draftMinPrice.value,
            max_price: draftMaxPrice.value >= priceBounds.value.max ? undefined : draftMaxPrice.value,
            page: undefined,
        });
    }

    function resetPriceSlider() {
        draftMinPrice.value = priceBounds.value.min;
        draftMaxPrice.value = priceBounds.value.max;
        applyPriceSlider();
    }

    function goToPage(page) {
        if (page < 1 || page > pagination.value.lastPage) {
            return;
        }

        updateRoute({
            ...route.query,
            page,
        });
    }

    function formatCurrency(value) {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            maximumFractionDigits: 0,
        }).format(Number(value || 0));
    }

    function handleDocumentClick(event) {
        if (!sortDropdownRef.value?.contains(event.target)) {
            sortDropdownOpen.value = false;
        }
    }

    async function loadCategories() {
        categoriesLoading.value = true;

        try {
            const response = await storefrontRequest('/categories');
            categories.value = (response.data || []).map(mapCategory);
        } catch (error) {
            categories.value = [];
        } finally {
            categoriesLoading.value = false;
        }
    }

    async function loadProducts() {
        productsLoading.value = true;
        productsError.value = '';

        try {
            const response = await storefrontRequest('/products', {
                params: {
                    category_id: selectedCategoryId.value,
                    search: route.query.search,
                    page: route.query.page || 1,
                    per_page: 6,
                    sort: selectedSort.value,
                    min_price: route.query.min_price,
                    max_price: route.query.max_price,
                },
            });

            products.value = (response.data || []).map(mapProductCard);
            priceBounds.value = {
                min: Number(response.price_bounds?.min || 0),
                max: Number(response.price_bounds?.max || 0),
            };
            draftMinPrice.value = currentMinPrice.value;
            draftMaxPrice.value = currentMaxPrice.value;
            pagination.value = {
                currentPage: response.current_page || 1,
                lastPage: response.last_page || 1,
                prevPage: response.prev_page_url,
                nextPage: response.next_page_url,
                total: response.total || 0,
            };
        } catch (error) {
            products.value = [];
            pagination.value = {
                currentPage: 1,
                lastPage: 1,
                prevPage: null,
                nextPage: null,
                total: 0,
            };
            productsError.value = error.message || 'Unable to load products right now.';
        } finally {
            productsLoading.value = false;
        }
    }

    watch(
        () => [route.query.category, route.query.search, route.query.page, route.query.sort, route.query.min_price, route.query.max_price],
        async () => {
            selectedSort.value = route.query.sort || 'featured';
            await loadProducts();
        },
    );

    // The home page's category tiles link straight to ?category=<id>, so this is a
    // landing page in its own right and should say which category it is showing. The
    // canonical stays on the bare /shop-v2 path (setSeo drops the query string), so
    // the filtered views do not compete with each other in search results.
    watch(selectedCategory, (category) => {
        setSeo({
            title: category ? category.name : 'Shop Furniture',
            description: category?.description
                || 'Browse sofas, armchairs, dining tables, beds and office furniture — in stock and made to order, delivered across Lebanon.',
            path: '/shop-v2',
        });
    });

    onMounted(async () => {
        Aos.init();
        document.addEventListener('click', handleDocumentClick);

        // loadProducts() reads the route query and selectedCategoryId, never the
        // loaded categories, so waiting for the sidebar before asking for the grid
        // only spent a round trip. Over the phone-testing tunnel that is a third of
        // a second before the first product is even requested.
        await Promise.all([loadCategories(), loadProducts()]);
    });

    onBeforeUnmount(() => {
        document.removeEventListener('click', handleDocumentClick);
    });
</script>

<style scoped>
.shop-range-input {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    background: transparent;
    pointer-events: none;
    -webkit-appearance: none;
    appearance: none;
}

.shop-range-input::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 18px;
    height: 18px;
    border-radius: 9999px;
    background: #c79a63;
    border: 2px solid #ffffff;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.18);
    cursor: pointer;
    pointer-events: auto;
}

.shop-range-input::-moz-range-thumb {
    width: 18px;
    height: 18px;
    border-radius: 9999px;
    background: #c79a63;
    border: 2px solid #ffffff;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.18);
    cursor: pointer;
    pointer-events: auto;
}

.shop-range-input::-webkit-slider-runnable-track {
    background: transparent;
}

.shop-range-input::-moz-range-track {
    background: transparent;
}
</style>
